import { Router } from '@angular/router';
import {Component, OnInit} from '@angular/core';
import {FormGroup, Validators} from '@angular/forms';
import {FormBuilder} from '@angular/forms';
import {HomeEstimatorService, Property} from '../../services/home-estimator.service';
import {HomeEstimatorRequest} from '../../services/home-estimator.service';
import {HomeEstimatorResponse} from '../../services/home-estimator.service';
import {ObjectResponse} from '../../classes/object-response';
import {Output} from '@angular/core';
import {EventEmitter} from '@angular/core';
import {HasSubscriptions} from '../has-subscriptions';
import {Input} from '@angular/core';
import {HomeEstimateRequest} from '../../services/home-estimator.service';

@Component({
  selector: 'app-home-estimator',
  templateUrl: './home-estimator.component.html',
  styleUrls: ['./home-estimator.component.scss']
})
export class HomeEstimatorComponent extends HasSubscriptions implements OnInit {
  @Input() standalone: boolean = false;
  homeEstimatorForm: FormGroup;
  homeEstimatorRequest: HomeEstimatorRequest = new HomeEstimatorRequest();
  homeEstimate: HomeEstimatorResponse;
  suggestions: Array<Property>;
  hasError: boolean = false;
  @Output() onContactAgent: EventEmitter<any> = new EventEmitter<any>();

  constructor(private fb: FormBuilder, private homeEstimatorService: HomeEstimatorService
    , private router: Router
  ) {
    super();
    this.homeEstimatorForm = this.fb.group({
      streetNumber: ['', Validators.required],
      streetName: ['', Validators.required],
      unitNumber: [''],
      city: [''],
      streetDirection: ['']
    });
  }

  ngOnInit() {
    this.addSub(this.homeEstimatorForm.valueChanges.subscribe((value) => {
      this.hasError = false;
    }));
  }

  getEstimate() {
    this.homeEstimatorRequest.streetName = this.homeEstimatorForm.controls['streetName'].value;
    this.homeEstimatorRequest.unitNumber = this.homeEstimatorForm.controls['unitNumber'].value;
    this.homeEstimatorRequest.streetDirection = this.homeEstimatorForm.controls['streetDirection'].value;
    this.homeEstimatorRequest.streetNumber = this.homeEstimatorForm.controls['streetNumber'].value;
    this.homeEstimatorRequest.location = this.homeEstimatorForm.controls['city'].value;
    this.homeEstimatorService.getSuggestions(this.homeEstimatorRequest).then((data: ObjectResponse<Property[]>) => {
      if (data.result.length === 0) {
        this.hasError = true;
      } else if (data.result.length === 1) {
        data.result[0].jurisdiction_Descp = data.result[0].jurisdiction_Descp.split(',')[0];
        this.getEstimateForSuggestion(data.result[0]);
      } else {
        this.suggestions = data.result.map(it => {
          it.jurisdiction_Descp = it.jurisdiction_Descp.split(',')[0];
          return it;
        });
      }
    }).catch((err) => {
      this.hasError = true;
    });
  }

  private mapRequest(data: Property) {
    const homeEstimateRequest: HomeEstimateRequest = new HomeEstimateRequest();
    homeEstimateRequest.rollNumber = data.roll_Number;
    homeEstimateRequest.jurisdictionCode = data.jurisdiction_Code;
    homeEstimateRequest.assessmentAreaCode = data.assessmentArea_Code;
    return homeEstimateRequest;
  }

  editForm() {
    this.homeEstimate = null;
    this.hasError = false;
  }

  getEstimateForSuggestion(property: Property) {
    this.homeEstimatorForm.controls['streetNumber'].patchValue(property.street_From);
    this.homeEstimatorForm.controls['streetName'].patchValue(property.street_Name);
    this.homeEstimatorForm.controls['unitNumber'].patchValue(property.apart_Suite);
    this.homeEstimatorForm.controls['streetDirection'].patchValue(property.street_Dir);
    this.homeEstimatorRequest.streetNumber = property.street_From;
    this.homeEstimatorRequest.streetName = property.street_Name;
    this.homeEstimatorRequest.streetDirection = property.street_Dir;
    this.homeEstimatorRequest.unitNumber = property.apart_Suite;
    const homeEstimateRequest = this.mapRequest(property);
    this.homeEstimatorService.getHomeEstimate(property).then((homeEstimate: ObjectResponse<HomeEstimatorResponse>) => {
      this.setHomeEstimate(homeEstimate.result);
    });
  }

  private setHomeEstimate(estimate: HomeEstimatorResponse) {
    this.suggestions = null;
    if (estimate.activeListingDetailUrl) {
      this.router.navigate([estimate.activeListingDetailUrl]);
      return;
    }
    this.homeEstimate = estimate;
  }

  closeSuggestions() {
    this.suggestions = null;
  }
}
